import { Component } from '@angular/core';

import { AppLayoutComponent } from './shared/layout/app-layout/app-layout.component';

@Component({
  selector: 'app-root',
  imports: [AppLayoutComponent],
  standalone: true,
  template: '<app-layout></app-layout>'
})
export class AppComponent {
  title = 'keynexis-binding-pwa';
}
